import { createSelector } from 'reselect';

import { createKeySelector } from 'Lib/reduxUtils';

import { getId } from 'Store/entities/utils';
import { getSelfieVerificationStatus } from 'Store/profile/selfieVerification.selectors';

import { SELFIE_VERIFICATION_VERIFIED } from 'Containers/ModalManager/modals/SelfieVerification/constants';

export const DEFAULT_PROFILE_ACTIVE_PHOTO_INDEX = 0;

export const selectAttributes = createKeySelector('attributes');

export const getProfilesAttributesById = createSelector(
  getId,
  selectAttributes,
  (id = '', entities) => entities?.profiles?.[id]
);

export const getProfilesActivePhotoIndexById = createSelector(
  getId,
  selectAttributes,
  (id = '', entities) =>
    entities?.profiles?.[id]?.activePhotoIndex ?? DEFAULT_PROFILE_ACTIVE_PHOTO_INDEX
);

export const getProfilesFurthestPhotoIndexById = createSelector(
  getId,
  selectAttributes,
  (id = '', entities) =>
    entities?.profiles?.[id]?.furthestPhotoIndex ?? DEFAULT_PROFILE_ACTIVE_PHOTO_INDEX
);

export const getProfilesConfirmedStatusById = createSelector(
  getId,
  selectAttributes,
  (id = '', entities) => entities?.profiles?.[id]?.confirmedStatus
);

export const getProfilesLikesYouConfirmedStatusById = createSelector(
  getId,
  selectAttributes,
  (id = '', entities) => entities?.profiles?.[id]?.likesYouConfirmedStatus
);

// Request Verification
export const getIsSelfieVerificationNeeded = createSelector(
  selectAttributes,
  getSelfieVerificationStatus,
  (entities, selfieVerificationStatus) => (matchId: string) =>
    selfieVerificationStatus !== SELFIE_VERIFICATION_VERIFIED &&
    (entities?.matches?.[matchId]?.requestVerification ?? false)
);
